<template>
  <div class="my-order">
    <div class="con-search">
      <van-field v-model="value" placeholder="搜索关键字" />
      <div class="s-icon" @click="onSearch">
        <img src="@/assets/publicImg/search.png" alt />
      </div>
    </div>
    <div class="order-div">
      <ul>
        <li
          @click="checkLi(item)"
          :class="onLi==item.type?'div-li div-onli':' div-li'"
          v-for="(item,index) in liList"
          :key="index"
        >{{item.name}}</li>
      </ul>
      <div class="order-sum">
        <div class="sum-box">
          <div class="box-title">本月业绩（万）</div>
          <div class="box-value">{{monthTotal}}</div>
        </div>
        <div class="sum-box">
          <div class="box-title">总业绩（万）</div>
          <div class="box-value">{{allTotal}}</div>
        </div>
      </div>
    </div>
    <div class="radio-div">
      <van-radio-group @change="onChangeOrder" class="group-box1" v-model="orderRadio" direction="horizontal">
        <van-radio name="personal" icon-size="11px">
          个人订单({{ radioData && radioData.personalOrderCount || 0}})
          <template #icon="props">
            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
          </template>
        </van-radio>
        <van-radio name="team" icon-size="11px">
          团队订单({{ radioData && radioData.teamOrderCount || 0}})
          <template #icon="props">
            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
          </template>
        </van-radio>
      </van-radio-group>
      <van-radio-group
        v-if="onLi=='loan'"
        @change="onChangeLoan"
        class="group-box2"
        v-model="statusRadio"
        direction="horizontal"
      >
        <van-radio name="0" icon-size="11px">
          申请中({{radioData && radioData.applying}})
          <template #icon="props">
            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
          </template>
        </van-radio>
        <van-radio name="1" icon-size="11px">
          审批通过({{radioData && radioData.passCount}})
          <template #icon="props">
            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
          </template>
        </van-radio>
        <van-radio name="2" icon-size="11px">
          已放款({{radioData && radioData.loanCount}})
          <template #icon="props">
            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
          </template>
        </van-radio>
        <van-radio name="3" icon-size="11px">
          已失败({{radioData && radioData.failedCount}})
          <template #icon="props">
            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
          </template>
        </van-radio>
      </van-radio-group>
      <van-radio-group v-else class="group-box2" v-model="safeStatusRadio" direction="horizontal">
        <van-radio name="0" icon-size="11px">
          申请中({{radioData && radioData.applying}})
          <template #icon="props">
            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
          </template>
        </van-radio>
        <van-radio name="1" icon-size="11px">
          审批通过({{radioData && radioData.passCount}})
          <template #icon="props">
            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
          </template>
        </van-radio>
        <van-radio name="2" icon-size="11px">
          已失效({{radioData && radioData.failedCount}})
          <template #icon="props">
            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
          </template>
        </van-radio>
      </van-radio-group>
    </div>
    <div v-if="onLi=='loan'">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div
            class="order-con"
            v-for="(item,index) in dataList"
            :key="index"
            @click="checkOrder(item)"
          >
            <div class="con-sty">
              <div>
                <div class="con-div">
                  <div>订单编号：{{item.orderId}}</div>
                  <div>产品名称：{{item.productName}}</div>
                </div>
                <div class="con-div">
                  <div>放款类型：{{item.loanTypeDesc}}</div>
                  <div>客户名称：{{item.cusName}}</div>
                </div>
                <div>进件时间：{{item.createTime}}</div>
                <div>放款时间：{{item.settlementEntryTime}}</div>
              </div>
              <img class="arrow" src="@/assets/publicImg/arrow.png" alt />
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div v-if="onLi=='insure'">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div
            class="order-con"
            v-for="(item,index) in dataList2"
            :key="index"
            @click="checkOrder1(item)"
          >
            <div class="con-sty">
              <div>
                <div class="con-div">
                  <div>订单编号：{{item.order}}</div>
                  <div>产品名称：{{item.pName}}</div>
                </div>
                <div class="con-div">
                  <div>放款类型：{{item.type}}</div>
                  <div>客户名称：{{item.name}}</div>
                </div>
                <div>进件时间：{{item.time1}}</div>
                <div>生效时间：{{item.time2}}</div>
                <div v-if="item.status=='2' || item.status=='3'">放款时间：{{item.time2}}</div>
              </div>
              <img class="arrow" src="@/assets/publicImg/arrow.png" alt />
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="order-but" @click="addBut">
      <img src="./img/but.png" alt />
    </div>
  </div>
</template>

<script>
import URLTB from "@/api/apiTB";
export default {
  data() {
    return {
      value: '',
      onLi: 'loan',
      liList: [
        { type: 'loan', name: '贷款' },
        { type: 'insure', name: '保险' },
      ],
      activeIcon: require('@/assets/publicImg/radio1.png'),
      inactiveIcon: require('@/assets/publicImg/radio0.png'),
      orderRadio: 'personal',//单选框 订单选中
      statusRadio: '0',//贷款 单选框 状态选中
      safeStatusRadio: '0',//保险 单选框 状态选中
      allTotal: '0',//总业绩
      monthTotal: '0',//本月业绩
      dataList: [],
      dataList2: [],
      radioData:{},//单选框（数据）
      loading: false,
      finished: false,
      refreshing: false,
      size: 10,//每页条数
      page:1,//当前页数
      total: 0,//总数据
      loan:true,//true 为贷款 
    }
  },
  methods: {
    onSearch(){//搜索
      this.dataList=[]
      this.getData()
    },
    onLoad() {//数据首次加载
      if(this.loan){
        this.getData()
      }else{
        this.getData()
      }
    },
    onRefresh() {//下拉刷新
      this.page=1
      this.loading=true
      this.finished=false
      if(this.loan){
        this.getloanData()
      }else{
        this.getInsureData()
      }
    },
    getloanData() {//贷款数据
      this.getData()
    },
    getInsureData() {//保险数据
      this.getData()
    },
    getData() {
      let data = {
        agentMobile: localStorage.getItem('phone'), // 代理人手机号
        userId: localStorage.getItem('userid'),// 代理人id
        searchStr: this.value,// 搜索条件
        listType: this.orderRadio,// 展示列表类型personal=个人订单  team=团队订单
        orderType: this.onLi, // 订单类型 loan=贷款  insure=保险
        page: this.page,
        size: this.size,
        status: this.statusRadio //订单状态 0-申请中 1-已完成 2-已放款 3-已拒绝
      }
      this.$fetchPost(URLTB.getOrder.url, data).then(res => {
        console.log(res);
        if (res.data.code == 20000) {
          this.refreshing = false
          this.loading = false
          this.allTotal = res.data.data.total
          this.monthTotal = res.data.data.monthTotal
          this.dataList2=[]
          this.radioData=res.data.data.count
          this.total = res.data.data.list.total
          let list = res.data.data.list.records
          // this.dataList = res.data.data.list.records
          if (list == null || list.length == 0) {
            //加载完成
            this.finished = true
            return
          }
          if (this.page > 1) {
            this.dataList = [...this.dataList, ...list]
          } else {
            this.dataList = list
          }
          // 如果当前数据条数>=总数据
          if (this.page * this.size >= this.total) {
            this.finished = true
            return
          }
          // 如果当前数据条数<总数据,页数+1
          if (this.page * this.size < this.total) {
            this.page++
          }
        }
      })
    },
    onChangeLoan(name) {
      this.statusRadio = name
      this.dataList=[]
      this.getData()
    },
    onChangeOrder(name){
      this.orderRadio = name
      this.dataList=[]
      this.getData()
    },
    checkLi(item) {
      this.onLi = item.type
      if(!item.type){
        this.radioData=''
        this.dataList=[]
        this.loan=false
        this.page=1
        this.loading=true
        this.finished=false
        this.getloanData()
      }else{
        this.radioData=''
        this.dataList2=[]
        this.loan=true
        this.page=1
        this.loading=true
        this.finished=false
        this.getInsureData()
      }
    },
    addBut() {
      this.$router.push('/addOrder')
    },
    checkOrder(item) {
      this.$router.push({ path: '/loanOrderDetail', query: { id: item.orderId } })
    },
    checkOrder1(item) {
      this.$router.push({ path: '/orderDetail', query: { id: item.id } })
    }
  }
}
</script>

<style lang="less" scoped>
.my-order {
  height: 100vh;
  background: #fff;
  overflow: scroll;
  font-family: Source Han Sans CN;
  .con-search {
    width: 355px;
    height: 30px;
    margin: 7px auto 8px auto;
    background: url("../../assets/publicImg/search-bg.png") no-repeat 100%;
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .van-cell {
      width: 300px;
      height: 30px;
      line-height: 30px;
      padding: 0 0 0 13px;
      background: transparent;
    }
    .s-icon {
      width: 40px;
      height: 30px;
      line-height: 27px;
      img {
        width: 14px;
        height: 14px;
        margin-left: 13px;
      }
    }
  }
  .order-div {
    width: 375px;
    height: auto;
    margin: auto;
    background: url("./img/bg.png") no-repeat 50%;
    background-size: 100% 100%;
    ul {
      display: flex;
      margin-top: 15px;
      .div-li {
        width: 188px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        // background: url("./img/bg1.png") no-repeat 100%;
        background: url("../../assets/publicImg/li-bg1.png") no-repeat 50%;
        background-size: 100% 100%;
      }
      .div-onli {
        background: url("./img/bg2.png") no-repeat 50%;
        color: #ffffff;
        // background-size: 100% 100%;
      }
    }
    .order-sum {
      display: flex;
      padding: 15px 0 12px 0;
      .sum-box {
        width: 188px;
        text-align: center;
        color: #333333;
        &:first-child {
          border-right: 1px solid #d5d5d5;
        }
        .box-title {
          font-size: 12px;
          font-weight: 400;
        }
        .box-value {
          font-size: 14px;
          font-weight: bold;
        }
      }
    }
  }
  .radio-div {
    height: 68px;
    margin-top: 10px;
    background: #fffbf8;
    border: 1px solid #fffbf8;
    .van-radio {
      height: 12px;
      margin: 15px 0 0;
      display: flex;
      justify-content: center;
      font-size: 11px;
      .img-icon {
        width: 11px;
      }
    }
    .group-box1 {
      .van-radio {
        width: 49%;
        &:first-child {
          border-right: 1px solid #d5d5d5;
        }
      }
    }
    .group-box2 {
      .van-radio {
        width: 23%;
        &:nth-child(2) {
          width: 29%;
        }
        &:not(:last-child) {
          border-right: 1px solid #d5d5d5;
        }
      }
    }
  }
  .order-con {
    width: 355px;
    height: 80px;
    background: url("../../assets/publicImg/con-bg.png") no-repeat 50%;
    background-size: 100% 100%;
    // padding: 13px 0;
    margin: 10px auto auto;
    font-size: 11px;
    font-weight: 400;
    color: #666666;
    position: relative;
    .con-sty {
      display: flex;
      width: 335px;
      align-items: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      justify-content: space-between;
    }
    .con-div {
      display: flex;
      div {
        &:last-child {
          margin-left: 15px;
        }
      }
    }
    .arrow {
      width: 5px;
      height: 7px;
    }
  }
  .order-but {
    width: 80px;
    height: 30px;
    margin: 30px 10px 49px 285px;
    img {
      width: 100%;
    }
  }
}
</style>